import { actionCreator } from 'utils';
import * as DesignLibraryTypes from '../types/designLibraryTypes';

const initState = {
    list: {
        designVariantId: null,
        loading: false,
        error: false,
        listing: null,
        offset: 0,
        limit: 50,
        sort: {
            key: 'created_at',
            type: 'desc',
        },
        filters: {
            quality: undefined,
            category: undefined,
            theme: undefined,
            subTheme: undefined,
            state: undefined,
            is_exclusive: undefined,
            size: '',
            ratio: '',
            border: undefined,
            prefix: '',
            customerId: '',
            librarySearch: '',
        },
        checked: {
            loading: false,
            ids: [],
        },
    },
    listDesignVariant: {
        loading: false,
        error: false,
        data: null,
        add: {
            loading: false,
        },
        offset: 0,
        limit: 10,
        edit: {
            loading: false,
            error: false,
            data: null,
        },
        inProgress: [],
    },
    selected: {
        loading: false,
        error: false,
        data: null,
    },
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
        currentToVariant: 1,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
    deleteDesignLibrary: {
        loading: false,
        error: false,
        success: false,
    },
    deleteDesignVariant: {
        loading: false,
        error: false,
        success: false,
    },
    settings: {
        selectedThemeId: null,
        editableSettingId: null,
        editingSettingValue: null,
        loadingType: {
            CATEGORY: false,
            THEME: false,
            SUB_THEME: false,
        },
        loading: false,
        error: false,
        listing: null,
        offset: 0,
        limit: 10000,
    },
    view: {
        loading: false,
        error: false,
        listing: null,
    },
    finishingPropertyValues: {
        loading: false,
        data: null,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case DesignLibraryTypes.LOAD_DESIGN_LIBRARY_LIST:
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                loading: true,
                error: false,
            },
        });
    case actionCreator(DesignLibraryTypes.LOAD_DESIGN_LIBRARY_LIST, 'res'):
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                listing: action.data,
                loading: false,
                error: false,
            },
        });
    case actionCreator(DesignLibraryTypes.LOAD_DESIGN_LIBRARY_LIST, 'err'):
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                loading: false,
                error: true,
            },
        });

    case DesignLibraryTypes.LOAD_FINISHING_PROPERTY_VALUES:
        return Object.assign({}, state, {
            ...state,
            finishingPropertyValues: {
                ...state.finishingPropertyValues,
                loading: true,
            },
        });
    case actionCreator(DesignLibraryTypes.LOAD_FINISHING_PROPERTY_VALUES, 'res'):
        return Object.assign({}, state, {
            ...state,
            finishingPropertyValues: {
                data: action.data,
                loading: false,
            },
        });
    case actionCreator(DesignLibraryTypes.LOAD_FINISHING_PROPERTY_VALUES, 'err'):
        return Object.assign({}, state, {
            ...state,
            finishingPropertyValues: {
                ...state.finishingPropertyValues,
                loading: false,
            },
        });

    case DesignLibraryTypes.SET_DESIGN_LIBRARY_FILTERS:
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                filters: {
                    ...state.list.filters,
                    [action.key]: action.value,
                },
            },
        });

    case DesignLibraryTypes.RESET_DESIGN_LIBRARY_FILTERS:
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                loading: true,
                filters: initState.list.filters,
            },
        });

    case DesignLibraryTypes.SET_DESIGN_LIBRARY_PAGINATION:
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                [action.key]: action.pagination,
            },
        });

    case DesignLibraryTypes.SET_DESIGN_LIBRARY_SORT:
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                sort: action.sort,
            },
        });

    case DesignLibraryTypes.SET_CHECKED_LIBRARYS:
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                checked: {
                    ...state.list.checked,
                    ids: action.ids,
                },
            },
        });

    case DesignLibraryTypes.RESET_DESIGN_LIBRARY_CHECKED:
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                checked: initState.list.checked,
            },
        });

    case DesignLibraryTypes.LOAD_DESIGN_LIBRARY_SETTINGS:
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                loading: true,
                error: false,
            },
        });
    case actionCreator(DesignLibraryTypes.LOAD_DESIGN_LIBRARY_SETTINGS, 'res'):
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                listing: action.data,
                loading: false,
                error: false,
                loadingType: {
                    ...state.settings.loadingType,
                    CATEGORY: false,
                    THEME: false,
                    SUB_THEME: false,
                },
            },
        });
    case actionCreator(DesignLibraryTypes.LOAD_DESIGN_LIBRARY_SETTINGS, 'err'):
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                loading: false,
                error: true,
                loadingType: {
                    ...state.settings.loadingType,
                    CATEGORY: false,
                    THEME: false,
                    SUB_THEME: false,
                },
            },
        });
    case DesignLibraryTypes.SET_SELECTED_THEME_ID:
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                selectedThemeId: action.data,
            },
        });
    case DesignLibraryTypes.SET_EDITABLE_SETTING_ID:
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                editableSettingId: action.data,
            },
        });
    case DesignLibraryTypes.SET_EDITING_SETTING_VALUE:
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                editingSettingValue: action.data,
            },
        });
    case DesignLibraryTypes.ADD_DESIGN_LIBRARY_SETTINGS:
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                loadingType: {
                    ...state.settings.loadingType,
                    [action.data.type]: true,
                },
            },
        });
    case DesignLibraryTypes.EDIT_DESIGN_LIBRARY_SETTINGS:
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                loadingType: {
                    ...state.settings.loadingType,
                    [action.data.type]: true,
                },
            },
        });

    case DesignLibraryTypes.DELETE_DESIGN_LIBRARY_SETTINGS:
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                loadingType: {
                    ...state.settings.loadingType,
                    [action.data.type]: true,
                },
            },
        });

    case actionCreator(DesignLibraryTypes.DELETE_DESIGN_LIBRARY_SETTINGS, 'err'):
        return Object.assign({}, state, {
            ...state,
            settings: {
                ...state.settings,
                loading: false,
                error: true,
                selectedThemeId: null,
                loadingType: {
                    ...state.settings.loadingType,
                    CATEGORY: false,
                    THEME: false,
                    SUB_THEME: false,
                },
            },
        });

    case DesignLibraryTypes.SET_DESIGN_VARIANT_PAGINATION:
        return Object.assign({}, state, {
            ...state,
            listDesignVariant: {
                ...state.listDesignVariant,
                [action.key]: action.pagination,
            },
        });


    case DesignLibraryTypes.ADD_DESIGN_LIBRARY:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(DesignLibraryTypes.ADD_DESIGN_LIBRARY, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: action.loading,
                error: false,
            }),
        });

    case actionCreator(DesignLibraryTypes.ADD_DESIGN_LIBRARY, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: action.error,
            }),
        });

    case DesignLibraryTypes.GO_TO_STEP_OF_DESIGN_FORM:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                current: action.step,
            }),
        });

    case DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_LIBRARY:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_LIBRARY, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_LIBRARY, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case DesignLibraryTypes.EDIT_DESIGN_LIBRARY:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(DesignLibraryTypes.EDIT_DESIGN_LIBRARY, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(DesignLibraryTypes.EDIT_DESIGN_LIBRARY, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case DesignLibraryTypes.ADD_DESIGN_VARIANT:
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                add: {
                    ...state.listDesignVariant.add,
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(DesignLibraryTypes.ADD_DESIGN_VARIANT, 'res'):
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                add: {
                    ...state.listDesignVariant.add,
                    loading: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(DesignLibraryTypes.ADD_DESIGN_VARIANT, 'err'):
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                add: {
                    ...state.listDesignVariant.add,
                    loading: false,
                    error: action.error,
                },
            }),
        });

    case DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_VARIANT:
        return Object.assign({}, state, {
            selected: {
                ...state.selected,
                loading: true,
                error: false,
            },
        });

    case actionCreator(DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_VARIANT, 'res'):
        return Object.assign({}, state, {
            selected: {
                ...state.selected,
                loading: false,
            },
        });

    case actionCreator(DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_VARIANT, 'err'):
        return Object.assign({}, state, {
            selected: {
                ...state.selected,
                loading: false,
                error: true,
            },
        });

    case DesignLibraryTypes.SET_SELECTED_DESIGN:
        return Object.assign({}, state, {
            selected: {
                ...state.selected,
                data: action.selected,
            },
        });


    case DesignLibraryTypes.SET_EDITABLE_DESIGN_VARIANT:
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                edit: {
                    ...state.listDesignVariant.edit,
                    data: action.data,
                },
            }),
        });

    case DesignLibraryTypes.SET_EDITABLE_IMAGE_FILE_DESIGN_VARIANT:
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                inProgress: [
                    ...state.listDesignVariant.inProgress,
                    action.data,
                ],
            }),
        });

    case DesignLibraryTypes.LOAD_LIBRARY_LIST:
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(DesignLibraryTypes.LOAD_LIBRARY_LIST, 'res'):
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(DesignLibraryTypes.LOAD_LIBRARY_LIST, 'err'):
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                loading: false,
                error: true,
            }),
        });

    case DesignLibraryTypes.LOAD_EDITABLE_DESIGN_LIBRARY_FOR_DESIGN:
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                edit: {
                    ...state.listDesignVariant.edit,
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(DesignLibraryTypes.LOAD_EDITABLE_DESIGN_LIBRARY_FOR_DESIGN, 'res'):
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                edit: {
                    ...state.listDesignVariant.edit,
                    data: action.data,
                    loading: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(DesignLibraryTypes.LOAD_EDITABLE_DESIGN_LIBRARY_FOR_DESIGN, 'err'):
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                edit: {
                    ...state.listDesignVariant.edit,
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case DesignLibraryTypes.EDIT_DESIGN_VARIANT:
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                edit: {
                    ...state.listDesignVariant.edit,
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(DesignLibraryTypes.EDIT_DESIGN_VARIANT, 'res'):
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                edit: {
                    ...state.listDesignVariant.edit,
                    loading: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(DesignLibraryTypes.EDIT_DESIGN_VARIANT, 'err'):
        return Object.assign({}, state, {
            listDesignVariant: Object.assign({}, state.listDesignVariant, {
                edit: {
                    ...state.listDesignVariant.edit,
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case DesignLibraryTypes.CLEAR_VIEW_DESIGN_LISTING:
        return Object.assign({}, state, {
            view: {
                ...state.view,
                listing: null,
            },
        });

    case DesignLibraryTypes.LOAD_VIEW_DESIGN_LIBRARY:
        return Object.assign({}, state, {
            view: {
                ...state.view,
                loading: true,
                error: false,
            },
        });

    case actionCreator(DesignLibraryTypes.LOAD_VIEW_DESIGN_LIBRARY, 'res'):
        return Object.assign({}, state, {
            view: {
                ...state.view,
                listing: action.data,
                loading: false,
                error: false,
            },
        });

    case actionCreator(DesignLibraryTypes.LOAD_VIEW_DESIGN_LIBRARY, 'err'):
        return Object.assign({}, state, {
            view: {
                ...state.view,
                loading: false,
                error: true,
            },
        });

    case DesignLibraryTypes.DELETE_DESIGN_LIBRARY:
        return Object.assign({}, state, {
            deleteDesignLibrary: Object.assign({}, state.deleteDesignLibrary, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(DesignLibraryTypes.DELETE_DESIGN_LIBRARY, 'res'):
        return Object.assign({}, state, {
            deleteDesignLibrary: Object.assign({}, state.deleteDesignLibrary, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(DesignLibraryTypes.DELETE_DESIGN_LIBRARY, 'err'):
        return Object.assign({}, state, {
            deleteDesignLibrary: Object.assign({}, state.deleteDesignLibrary, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case DesignLibraryTypes.DELETE_DESIGN_VARIANT:
        return Object.assign({}, state, {
            deleteDesignVariant: Object.assign({}, state.deleteDesignVariant, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(DesignLibraryTypes.DELETE_DESIGN_VARIANT, 'res'):
        return Object.assign({}, state, {
            deleteDesignVariant: Object.assign({}, state.deleteDesignVariant, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(DesignLibraryTypes.DELETE_DESIGN_VARIANT, 'err'):
        return Object.assign({}, state, {
            deleteDesignVariant: Object.assign({}, state.deleteDesignVariant, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case DesignLibraryTypes.SET_DESIGN_VARIANT_ID:
        return Object.assign({}, state, {
            ...state,
            list: {
                ...state.list,
                designVariantId: action.id,
            },
        });

    default:
        return state;
    }
}
